import { render, staticRenderFns } from "./XFJD.vue?vue&type=template&id=63a8e6ca&scoped=true&"
import script from "./XFJD.vue?vue&type=script&lang=js&"
export * from "./XFJD.vue?vue&type=script&lang=js&"
import style0 from "./XFJD.vue?vue&type=style&index=0&id=63a8e6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8e6ca",
  null
  
)

export default component.exports